module.exports = __webpack_public_path__ + "static/assets/f1ca57a3e9312a5e53dd50a1fb0bd26a.png";